"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.notifications = void 0;
const basic_1 = require("../basic");
exports.notifications = (0, basic_1.applyBase)({
    notificationInfo: {
        display: 'flex',
        flexShrink: 0,
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '0px',
        borderBottom: '1px solid',
        borderColor: 'lightGreyFirst',
        py: 1,
        'a:hover': {
            color: 'primary',
        },
        overflow: 'hidden',
    },
    notificationInfoContent: {
        '*, p': {
            fontSize: 1,
        },
    },
    mantainanceNotification: {
        position: 'fixed',
        bottom: ['0px', 5],
        left: [null, '50%'],
        transform: [null, 'translate(-50%)'],
        width: '100%',
        maxWidth: '770px',
        borderRadius: 'default',
        zIndex: '10',
        overflow: [null, 'hidden'],
        boxShadow: 'notificationShadow',
        '.notification-body': {
            backgroundColor: 'white',
            color: 'black',
        },
        variant: 'text.richText',
        'p:last-child': {
            mb: 0,
        },
    },
});
//# sourceMappingURL=notifications.js.map